import React, { useState } from 'react';
import { useAPI } from '../../api';
import { WorkspaceInfo } from 'types';
import { useOrgContext, useOrgNavigate } from 'components/OrgContextProvider';

interface WorkspaceCreateNewContainerProps {
	onChanged: () => void;
}

const WorkspaceCreateNewContainer = ({ onChanged }: WorkspaceCreateNewContainerProps) => {
	const api = useAPI();
	const ctx = useOrgContext();
	const orgNavigate = useOrgNavigate();

	const [name, setName] = useState('');
	const [id, setId] = useState('');

	const createWorkspace = () => {
		if (!ctx?.tenantID) return alert('Please select a tenant');
		if (!name.trim()) return alert('Workspace name is required');

		api.post<WorkspaceInfo>(`/api/t/${ctx.tenantID}/workspaces`, { id, name })
		.then(json => { onChanged(); orgNavigate(`/settings/workspaces/${json.id}`, { level: 'tenant' }); })
		.then(() => ctx?.reload?.());
	};

	return (
		<div>
			<h2>Create new workspace</h2>

			<hr />

			<table>
				<tbody>
					<tr>
						<td>Workspace Name</td>
						<td><input type="text" value={name} onChange={e => setName(e.target.value)} /></td>
					</tr>
					<tr>
						<td>Workspace ID (optional)</td>
						<td><input type="text" value={id} onChange={e => setId(e.target.value)} /></td>
					</tr>
					<tr>
						<td></td>
						<td><input type="button" value="Create Workspace" onClick={createWorkspace} /></td>
					</tr>
				</tbody>
			</table>
		</div>
	);
};

export default WorkspaceCreateNewContainer;
